google.maps.event.addDomListener(window, 'load', function () {
  var map = new google.maps.Map(document.getElementById('map-canvas'), {
    center: new google.maps.LatLng(37.8402552, -102.1673725),
    zoom: 5,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ]
  });


  var data = new DaiwaDataSource;
  
  var view = new storeLocator.View(map, data, {
    geolocation: true,
    features: data.getFeatures()
  });

  view.createMarker = function (store) {
    var markerOptions = {
      position: store.getLocation(),
      icon: store.getDetails().category,
      title: store.getDetails().title,
    }
    marker = new google.maps.Marker(markerOptions);
    return marker;
  }

  var panelDiv = document.getElementById('panel');
  
  var mainPanel = new storeLocator.Panel(panelDiv, {
    view: view,
    directions: false
  });

  view.addListener('selectedStore_changed',function(){
    var target = "#panel";
    if($(target).hasClass('list-shown')){
      $('#panel').removeClass('list-shown');
      $('#panel .btn').text('list');
    }
  })
});/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function DaiwaDataSource() {
  $.extend(this, new storeLocator.StaticDataFeed);

  var that = this;
  $.get(window.DAIWA_SHEETS_PROXY + '/sheets/dealers?ranges=A1:Z100000', function (data) {
    var csv = '';  
for (i = 0; i < data.valueRanges['0'].values.length; i++) { 
  var cellData = [];
  for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
    // Replace commas with semicolons to avoid CSV parsing issues
    var cellValue = data.valueRanges['0'].values[i][x];
    if (cellValue) {
      cellData[x] = '"' + cellValue.replace(/"/g, '""').replace(',', ';') + '"';
    } else {
      cellData[x] = '""';
    }
  }
  csv += cellData.join(',') + '\n';
}
that.setStores(that.parse_(csv));
  });
}
/**
 * @const
 * @type {!storeLocator.FeatureSet}
 * @private
 */

DaiwaDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
  new storeLocator.Feature('Dealer-Yes', 'Dealer'),
  new storeLocator.Feature('Kage-Yes', 'Kage'),
  new storeLocator.Feature('Warranty-Yes', 'Warranty'),
  new storeLocator.Feature('Service-Yes', 'Service'),
  new storeLocator.Feature('AGS-Yes', 'AGS Guide')
);
  

/**
 * @return {!storeLocator.FeatureSet}
 */
DaiwaDataSource.prototype.getFeatures = function () {
  return this.FEATURES_;
};

/**
 * @private
 * @param {string} csv
 * @return {!Array.<!storeLocator.Store>}
 */
DaiwaDataSource.prototype.parse_ = function (csv) {

  var stores = [];
  var rows = csv.split('\n');
  var headings = this.parseRow_(rows[0]);

  for (var i = 1; i < rows.length; i++) {
    if (!rows[i].trim()) continue; // Skip empty rows
    
    var rowData = this.parseRow_(rows[i]);
    var singleObject = {};
    
    for (var x = 0; x < headings.length && x < rowData.length; x++) {
      if (rowData[x] != null && rowData[x] !== '') {
        // Convert semicolons back to commas and remove quotes
        var cleanValue = rowData[x].replace(/^"|"$/g, '').replace(/""/g, '"').replace(';', ',');
        var cleanHeader = headings[x].replace(/(\r\n|\n|\r)/gm, "");
        singleObject[cleanHeader] = cleanValue;
      }
    }

    if (!singleObject.Latitude || !singleObject.Longitude || isNaN(parseFloat(singleObject.Latitude)) || isNaN(parseFloat(singleObject.Longitude))) continue;
    var position = new google.maps.LatLng(parseFloat(singleObject.Latitude), parseFloat(singleObject.Longitude));
    var street = this.join_([singleObject.Address, singleObject.Address2], ' ');
    var shop = this.join_([street, singleObject.City], ', ');
    var locality = this.join_([singleObject.State, singleObject.Zip], ', ');
    var callus = new storeLocator.Feature('1', '<a class="action directions callUs" href="tel:' + singleObject.Phone + '" onclick="clickCallStore(\'' + singleObject.Name + '\')">CALL US</a>');
    var directions = new storeLocator.Feature('2', '<a class="action directions" href="https://www.google.com/maps/search/?api=1&query=' + shop.split(' ').join('+') + ',' + locality.split(' ').join('+') + '" onclick="clickDirectionStore(\'' + singleObject.Name + '\')" target="_blank">DIRECTIONS</a>');
    var features = new storeLocator.FeatureSet(callus, directions);

    // var features = new storeLocator.FeatureSet;
    features.add(this.FEATURES_.getById(singleObject.Phone));
    features.add(this.FEATURES_.getById(singleObject.Name));
    features.add(this.FEATURES_.getById('Dealer-' + singleObject.Dealer));
    features.add(this.FEATURES_.getById('Kage-' + singleObject.Kage));
    features.add(this.FEATURES_.getById('Warranty-' + singleObject.Warranty));
    features.add(this.FEATURES_.getById('Service-' + singleObject.Service));
    features.add(this.FEATURES_.getById('AGS-' + singleObject.AGS));

    if (singleObject.Phone == null) {
      var isTelHidden = 'd-none';
    } else {
      var isTelHidden = '';
    }

    var store = new storeLocator.Store(i, position, features, {
      title: singleObject.Name,
      address: this.join_([shop, locality], '<br>'),
      category: window.shopifyFilesUrl + singleObject.Category + '-marker.png?16296',
      phone: '<a href="tel:' + singleObject.Phone + '" onclick="clickCallStore(\'' + singleObject.Name + '\')" class="' + isTelHidden + '">' + singleObject.Phone + '</a>'
    });
    stores.push(store);
  }

  return stores;

};


/**
 * Joins elements of an array that are non-empty and non-null.
 * @private
 * @param {!Array} arr array of elements to join.
 * @param {string} sep the separator.
 * @return {string}
 */
DaiwaDataSource.prototype.join_ = function (arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};

/**
 * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
 * IMPORTANT: Don't use this for general CSV parsing!
 * @private
 * @param {string} row
 * @return {Array.<string>}
 */
DaiwaDataSource.prototype.parseRow_ = function (row) {
  // Handle properly formatted CSV with quoted fields
if (row.trim() === '') {
  return [];
}

// Parse CSV row with quoted fields
var fields = [];
var currentField = '';
var inQuotes = false;
var escapeNext = false;

for (var i = 0; i < row.length; i++) {
  var char = row[i];
  
  if (escapeNext) {
    currentField += char;
    escapeNext = false;
    continue;
  }
  
  if (char === '"') {
    if (inQuotes) {
      // Check if this is an escaped quote
      if (i + 1 < row.length && row[i + 1] === '"') {
        currentField += '"';
        escapeNext = true;
      } else {
        inQuotes = false;
      }
    } else {
      inQuotes = true;
    }
  } else if (char === ',' && !inQuotes) {
    fields.push(currentField.trim());
    currentField = '';
  } else {
    currentField += char;
  }
}

// Add the last field
fields.push(currentField.trim());

return fields;
};

/**
 * Creates an object mapping headings to row elements.
 * @private
 * @param {Array.<string>} headings
 * @param {Array.<string>} row
 * @return {Object}
 */
DaiwaDataSource.prototype.toObject_ = function (headings, row) {
  var result = {};
  for (var i = 0, ii = row.length; i < ii; i++) {
    result[headings[i]] = row[i];
  }
  return result;
};